import { render } from "./LevelResult.vue?vue&type=template&id=4d67fcc7&scoped=true"
import script from "./LevelResult.vue?vue&type=script&lang=js"
export * from "./LevelResult.vue?vue&type=script&lang=js"

import "./LevelResult.vue?vue&type=style&index=0&id=4d67fcc7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d67fcc7"]])

export default __exports__